export default __webpack_public_path__ + "static/media/robi_logo.02b096c4.svg";